var _a;
export var BlueprintIcons_16;
(function (BlueprintIcons_16) {
    BlueprintIcons_16["AddColumnLeft"] = "add-column-left";
    BlueprintIcons_16["AddColumnRight"] = "add-column-right";
    BlueprintIcons_16["AddLocation"] = "add-location";
    BlueprintIcons_16["AddRowBottom"] = "add-row-bottom";
    BlueprintIcons_16["AddRowTop"] = "add-row-top";
    BlueprintIcons_16["AddToArtifact"] = "add-to-artifact";
    BlueprintIcons_16["AddToFolder"] = "add-to-folder";
    BlueprintIcons_16["Add"] = "add";
    BlueprintIcons_16["Airplane"] = "airplane";
    BlueprintIcons_16["AlignCenter"] = "align-center";
    BlueprintIcons_16["AlignJustify"] = "align-justify";
    BlueprintIcons_16["AlignLeft"] = "align-left";
    BlueprintIcons_16["AlignRight"] = "align-right";
    BlueprintIcons_16["AlignmentBottom"] = "alignment-bottom";
    BlueprintIcons_16["AlignmentHorizontalCenter"] = "alignment-horizontal-center";
    BlueprintIcons_16["AlignmentLeft"] = "alignment-left";
    BlueprintIcons_16["AlignmentRight"] = "alignment-right";
    BlueprintIcons_16["AlignmentTop"] = "alignment-top";
    BlueprintIcons_16["AlignmentVerticalCenter"] = "alignment-vertical-center";
    BlueprintIcons_16["Annotation"] = "annotation";
    BlueprintIcons_16["AppHeader"] = "app-header";
    BlueprintIcons_16["Application"] = "application";
    BlueprintIcons_16["Applications"] = "applications";
    BlueprintIcons_16["Archive"] = "archive";
    BlueprintIcons_16["ArrayBoolean"] = "array-boolean";
    BlueprintIcons_16["ArrayDate"] = "array-date";
    BlueprintIcons_16["ArrayNumeric"] = "array-numeric";
    BlueprintIcons_16["ArrayString"] = "array-string";
    BlueprintIcons_16["ArrayTimestamp"] = "array-timestamp";
    BlueprintIcons_16["Array"] = "array";
    BlueprintIcons_16["ArrowBottomLeft"] = "arrow-bottom-left";
    BlueprintIcons_16["ArrowBottomRight"] = "arrow-bottom-right";
    BlueprintIcons_16["ArrowDown"] = "arrow-down";
    BlueprintIcons_16["ArrowLeft"] = "arrow-left";
    BlueprintIcons_16["ArrowRight"] = "arrow-right";
    BlueprintIcons_16["ArrowTopLeft"] = "arrow-top-left";
    BlueprintIcons_16["ArrowTopRight"] = "arrow-top-right";
    BlueprintIcons_16["ArrowUp"] = "arrow-up";
    BlueprintIcons_16["ArrowsHorizontal"] = "arrows-horizontal";
    BlueprintIcons_16["ArrowsVertical"] = "arrows-vertical";
    BlueprintIcons_16["Asterisk"] = "asterisk";
    BlueprintIcons_16["AutomaticUpdates"] = "automatic-updates";
    BlueprintIcons_16["Backlink"] = "backlink";
    BlueprintIcons_16["Badge"] = "badge";
    BlueprintIcons_16["BanCircle"] = "ban-circle";
    BlueprintIcons_16["BankAccount"] = "bank-account";
    BlueprintIcons_16["Barcode"] = "barcode";
    BlueprintIcons_16["Blank"] = "blank";
    BlueprintIcons_16["BlockedPerson"] = "blocked-person";
    BlueprintIcons_16["Bold"] = "bold";
    BlueprintIcons_16["Book"] = "book";
    BlueprintIcons_16["Bookmark"] = "bookmark";
    BlueprintIcons_16["Box"] = "box";
    BlueprintIcons_16["Briefcase"] = "briefcase";
    BlueprintIcons_16["BringData"] = "bring-data";
    BlueprintIcons_16["Build"] = "build";
    BlueprintIcons_16["Calculator"] = "calculator";
    BlueprintIcons_16["Calendar"] = "calendar";
    BlueprintIcons_16["Camera"] = "camera";
    BlueprintIcons_16["CaretDown"] = "caret-down";
    BlueprintIcons_16["CaretLeft"] = "caret-left";
    BlueprintIcons_16["CaretRight"] = "caret-right";
    BlueprintIcons_16["CaretUp"] = "caret-up";
    BlueprintIcons_16["CellTower"] = "cell-tower";
    BlueprintIcons_16["Changes"] = "changes";
    BlueprintIcons_16["Chart"] = "chart";
    BlueprintIcons_16["Chat"] = "chat";
    BlueprintIcons_16["ChevronBackward"] = "chevron-backward";
    BlueprintIcons_16["ChevronDown"] = "chevron-down";
    BlueprintIcons_16["ChevronForward"] = "chevron-forward";
    BlueprintIcons_16["ChevronLeft"] = "chevron-left";
    BlueprintIcons_16["ChevronRight"] = "chevron-right";
    BlueprintIcons_16["ChevronUp"] = "chevron-up";
    BlueprintIcons_16["CircleArrowDown"] = "circle-arrow-down";
    BlueprintIcons_16["CircleArrowLeft"] = "circle-arrow-left";
    BlueprintIcons_16["CircleArrowRight"] = "circle-arrow-right";
    BlueprintIcons_16["CircleArrowUp"] = "circle-arrow-up";
    BlueprintIcons_16["Circle"] = "circle";
    BlueprintIcons_16["Citation"] = "citation";
    BlueprintIcons_16["Clean"] = "clean";
    BlueprintIcons_16["Clipboard"] = "clipboard";
    BlueprintIcons_16["CloudDownload"] = "cloud-download";
    BlueprintIcons_16["CloudUpload"] = "cloud-upload";
    BlueprintIcons_16["Cloud"] = "cloud";
    BlueprintIcons_16["CodeBlock"] = "code-block";
    BlueprintIcons_16["Code"] = "code";
    BlueprintIcons_16["Cog"] = "cog";
    BlueprintIcons_16["CollapseAll"] = "collapse-all";
    BlueprintIcons_16["ColumnLayout"] = "column-layout";
    BlueprintIcons_16["Comment"] = "comment";
    BlueprintIcons_16["Comparison"] = "comparison";
    BlueprintIcons_16["Compass"] = "compass";
    BlueprintIcons_16["Compressed"] = "compressed";
    BlueprintIcons_16["Confirm"] = "confirm";
    BlueprintIcons_16["Console"] = "console";
    BlueprintIcons_16["Contrast"] = "contrast";
    BlueprintIcons_16["Control"] = "control";
    BlueprintIcons_16["CreditCard"] = "credit-card";
    BlueprintIcons_16["Cross"] = "cross";
    BlueprintIcons_16["Crown"] = "crown";
    BlueprintIcons_16["CubeAdd"] = "cube-add";
    BlueprintIcons_16["CubeRemove"] = "cube-remove";
    BlueprintIcons_16["Cube"] = "cube";
    BlueprintIcons_16["CurvedRangeChart"] = "curved-range-chart";
    BlueprintIcons_16["Cut"] = "cut";
    BlueprintIcons_16["Cycle"] = "cycle";
    BlueprintIcons_16["Dashboard"] = "dashboard";
    BlueprintIcons_16["DataConnection"] = "data-connection";
    BlueprintIcons_16["DataLineage"] = "data-lineage";
    BlueprintIcons_16["Database"] = "database";
    BlueprintIcons_16["Delete"] = "delete";
    BlueprintIcons_16["Delta"] = "delta";
    BlueprintIcons_16["DeriveColumn"] = "derive-column";
    BlueprintIcons_16["Desktop"] = "desktop";
    BlueprintIcons_16["Diagnosis"] = "diagnosis";
    BlueprintIcons_16["DiagramTree"] = "diagram-tree";
    BlueprintIcons_16["DirectionLeft"] = "direction-left";
    BlueprintIcons_16["DirectionRight"] = "direction-right";
    BlueprintIcons_16["Disable"] = "disable";
    BlueprintIcons_16["DocumentOpen"] = "document-open";
    BlueprintIcons_16["DocumentShare"] = "document-share";
    BlueprintIcons_16["Document"] = "document";
    BlueprintIcons_16["Dollar"] = "dollar";
    BlueprintIcons_16["Dot"] = "dot";
    BlueprintIcons_16["DoubleCaretHorizontal"] = "double-caret-horizontal";
    BlueprintIcons_16["DoubleCaretVertical"] = "double-caret-vertical";
    BlueprintIcons_16["DoubleChevronDown"] = "double-chevron-down";
    BlueprintIcons_16["DoubleChevronLeft"] = "double-chevron-left";
    BlueprintIcons_16["DoubleChevronRight"] = "double-chevron-right";
    BlueprintIcons_16["DoubleChevronUp"] = "double-chevron-up";
    BlueprintIcons_16["DoughnutChart"] = "doughnut-chart";
    BlueprintIcons_16["Download"] = "download";
    BlueprintIcons_16["DragHandleHorizontal"] = "drag-handle-horizontal";
    BlueprintIcons_16["DragHandleVertical"] = "drag-handle-vertical";
    BlueprintIcons_16["Draw"] = "draw";
    BlueprintIcons_16["DrawerLeftFilled"] = "drawer-left-filled";
    BlueprintIcons_16["DrawerLeft"] = "drawer-left";
    BlueprintIcons_16["DrawerRightFilled"] = "drawer-right-filled";
    BlueprintIcons_16["DrawerRight"] = "drawer-right";
    BlueprintIcons_16["DriveTime"] = "drive-time";
    BlueprintIcons_16["Duplicate"] = "duplicate";
    BlueprintIcons_16["Edit"] = "edit";
    BlueprintIcons_16["Eject"] = "eject";
    BlueprintIcons_16["Emoji"] = "emoji";
    BlueprintIcons_16["Endorsed"] = "endorsed";
    BlueprintIcons_16["Envelope"] = "envelope";
    BlueprintIcons_16["Equals"] = "equals";
    BlueprintIcons_16["Eraser"] = "eraser";
    BlueprintIcons_16["Error"] = "error";
    BlueprintIcons_16["Euro"] = "euro";
    BlueprintIcons_16["Exchange"] = "exchange";
    BlueprintIcons_16["ExcludeRow"] = "exclude-row";
    BlueprintIcons_16["ExpandAll"] = "expand-all";
    BlueprintIcons_16["Export"] = "export";
    BlueprintIcons_16["EyeOff"] = "eye-off";
    BlueprintIcons_16["EyeOn"] = "eye-on";
    BlueprintIcons_16["EyeOpen"] = "eye-open";
    BlueprintIcons_16["FastBackward"] = "fast-backward";
    BlueprintIcons_16["FastForward"] = "fast-forward";
    BlueprintIcons_16["FeedSubscribed"] = "feed-subscribed";
    BlueprintIcons_16["Feed"] = "feed";
    BlueprintIcons_16["Film"] = "film";
    BlueprintIcons_16["FilterKeep"] = "filter-keep";
    BlueprintIcons_16["FilterList"] = "filter-list";
    BlueprintIcons_16["FilterOpen"] = "filter-open";
    BlueprintIcons_16["FilterRemove"] = "filter-remove";
    BlueprintIcons_16["Filter"] = "filter";
    BlueprintIcons_16["Flag"] = "flag";
    BlueprintIcons_16["Flame"] = "flame";
    BlueprintIcons_16["Flash"] = "flash";
    BlueprintIcons_16["FloppyDisk"] = "floppy-disk";
    BlueprintIcons_16["FlowBranch"] = "flow-branch";
    BlueprintIcons_16["FlowEnd"] = "flow-end";
    BlueprintIcons_16["FlowLinear"] = "flow-linear";
    BlueprintIcons_16["FlowReviewBranch"] = "flow-review-branch";
    BlueprintIcons_16["FlowReview"] = "flow-review";
    BlueprintIcons_16["Flows"] = "flows";
    BlueprintIcons_16["FolderClose"] = "folder-close";
    BlueprintIcons_16["FolderNew"] = "folder-new";
    BlueprintIcons_16["FolderOpen"] = "folder-open";
    BlueprintIcons_16["FolderSharedOpen"] = "folder-shared-open";
    BlueprintIcons_16["FolderShared"] = "folder-shared";
    BlueprintIcons_16["Follower"] = "follower";
    BlueprintIcons_16["Following"] = "following";
    BlueprintIcons_16["Font"] = "font";
    BlueprintIcons_16["Fork"] = "fork";
    BlueprintIcons_16["Form"] = "form";
    BlueprintIcons_16["FullCircle"] = "full-circle";
    BlueprintIcons_16["FullStackedChart"] = "full-stacked-chart";
    BlueprintIcons_16["Fullscreen"] = "fullscreen";
    BlueprintIcons_16["Function"] = "function";
    BlueprintIcons_16["GanttChart"] = "gantt-chart";
    BlueprintIcons_16["Geofence"] = "geofence";
    BlueprintIcons_16["Geolocation"] = "geolocation";
    BlueprintIcons_16["Geosearch"] = "geosearch";
    BlueprintIcons_16["GitBranch"] = "git-branch";
    BlueprintIcons_16["GitCommit"] = "git-commit";
    BlueprintIcons_16["GitMerge"] = "git-merge";
    BlueprintIcons_16["GitNewBranch"] = "git-new-branch";
    BlueprintIcons_16["GitPull"] = "git-pull";
    BlueprintIcons_16["GitPush"] = "git-push";
    BlueprintIcons_16["GitRepo"] = "git-repo";
    BlueprintIcons_16["Glass"] = "glass";
    BlueprintIcons_16["GlobeNetwork"] = "globe-network";
    BlueprintIcons_16["Globe"] = "globe";
    BlueprintIcons_16["GraphRemove"] = "graph-remove";
    BlueprintIcons_16["Graph"] = "graph";
    BlueprintIcons_16["GreaterThanOrEqualTo"] = "greater-than-or-equal-to";
    BlueprintIcons_16["GreaterThan"] = "greater-than";
    BlueprintIcons_16["GridView"] = "grid-view";
    BlueprintIcons_16["Grid"] = "grid";
    BlueprintIcons_16["GroupObjects"] = "group-objects";
    BlueprintIcons_16["GroupedBarChart"] = "grouped-bar-chart";
    BlueprintIcons_16["HandDown"] = "hand-down";
    BlueprintIcons_16["HandLeft"] = "hand-left";
    BlueprintIcons_16["HandRight"] = "hand-right";
    BlueprintIcons_16["HandUp"] = "hand-up";
    BlueprintIcons_16["Hand"] = "hand";
    BlueprintIcons_16["Hat"] = "hat";
    BlueprintIcons_16["HeaderOne"] = "header-one";
    BlueprintIcons_16["HeaderTwo"] = "header-two";
    BlueprintIcons_16["Header"] = "header";
    BlueprintIcons_16["Headset"] = "headset";
    BlueprintIcons_16["HeartBroken"] = "heart-broken";
    BlueprintIcons_16["Heart"] = "heart";
    BlueprintIcons_16["HeatGrid"] = "heat-grid";
    BlueprintIcons_16["Heatmap"] = "heatmap";
    BlueprintIcons_16["Help"] = "help";
    BlueprintIcons_16["HelperManagement"] = "helper-management";
    BlueprintIcons_16["HighPriority"] = "high-priority";
    BlueprintIcons_16["Highlight"] = "highlight";
    BlueprintIcons_16["History"] = "history";
    BlueprintIcons_16["Home"] = "home";
    BlueprintIcons_16["HorizontalBarChartAsc"] = "horizontal-bar-chart-asc";
    BlueprintIcons_16["HorizontalBarChartDesc"] = "horizontal-bar-chart-desc";
    BlueprintIcons_16["HorizontalBarChart"] = "horizontal-bar-chart";
    BlueprintIcons_16["HorizontalDistribution"] = "horizontal-distribution";
    BlueprintIcons_16["IdNumber"] = "id-number";
    BlueprintIcons_16["ImageRotateLeft"] = "image-rotate-left";
    BlueprintIcons_16["ImageRotateRight"] = "image-rotate-right";
    BlueprintIcons_16["Import"] = "import";
    BlueprintIcons_16["InboxFiltered"] = "inbox-filtered";
    BlueprintIcons_16["InboxGeo"] = "inbox-geo";
    BlueprintIcons_16["InboxSearch"] = "inbox-search";
    BlueprintIcons_16["InboxUpdate"] = "inbox-update";
    BlueprintIcons_16["Inbox"] = "inbox";
    BlueprintIcons_16["InfoSign"] = "info-sign";
    BlueprintIcons_16["Inheritance"] = "inheritance";
    BlueprintIcons_16["InheritedGroup"] = "inherited-group";
    BlueprintIcons_16["InnerJoin"] = "inner-join";
    BlueprintIcons_16["Insert"] = "insert";
    BlueprintIcons_16["Intersection"] = "intersection";
    BlueprintIcons_16["IpAddress"] = "ip-address";
    BlueprintIcons_16["IssueClosed"] = "issue-closed";
    BlueprintIcons_16["IssueNew"] = "issue-new";
    BlueprintIcons_16["Issue"] = "issue";
    BlueprintIcons_16["Italic"] = "italic";
    BlueprintIcons_16["JoinTable"] = "join-table";
    BlueprintIcons_16["KeyBackspace"] = "key-backspace";
    BlueprintIcons_16["KeyCommand"] = "key-command";
    BlueprintIcons_16["KeyControl"] = "key-control";
    BlueprintIcons_16["KeyDelete"] = "key-delete";
    BlueprintIcons_16["KeyEnter"] = "key-enter";
    BlueprintIcons_16["KeyEscape"] = "key-escape";
    BlueprintIcons_16["KeyOption"] = "key-option";
    BlueprintIcons_16["KeyShift"] = "key-shift";
    BlueprintIcons_16["KeyTab"] = "key-tab";
    BlueprintIcons_16["Key"] = "key";
    BlueprintIcons_16["KnownVehicle"] = "known-vehicle";
    BlueprintIcons_16["LabTest"] = "lab-test";
    BlueprintIcons_16["Label"] = "label";
    BlueprintIcons_16["LayerOutline"] = "layer-outline";
    BlueprintIcons_16["Layer"] = "layer";
    BlueprintIcons_16["Layers"] = "layers";
    BlueprintIcons_16["LayoutAuto"] = "layout-auto";
    BlueprintIcons_16["LayoutBalloon"] = "layout-balloon";
    BlueprintIcons_16["LayoutCircle"] = "layout-circle";
    BlueprintIcons_16["LayoutGrid"] = "layout-grid";
    BlueprintIcons_16["LayoutGroupBy"] = "layout-group-by";
    BlueprintIcons_16["LayoutHierarchy"] = "layout-hierarchy";
    BlueprintIcons_16["LayoutLinear"] = "layout-linear";
    BlueprintIcons_16["LayoutSkewGrid"] = "layout-skew-grid";
    BlueprintIcons_16["LayoutSortedClusters"] = "layout-sorted-clusters";
    BlueprintIcons_16["Layout"] = "layout";
    BlueprintIcons_16["Learning"] = "learning";
    BlueprintIcons_16["LeftJoin"] = "left-join";
    BlueprintIcons_16["LessThanOrEqualTo"] = "less-than-or-equal-to";
    BlueprintIcons_16["LessThan"] = "less-than";
    BlueprintIcons_16["Lifesaver"] = "lifesaver";
    BlueprintIcons_16["Lightbulb"] = "lightbulb";
    BlueprintIcons_16["Link"] = "link";
    BlueprintIcons_16["ListColumns"] = "list-columns";
    BlueprintIcons_16["ListDetailView"] = "list-detail-view";
    BlueprintIcons_16["List"] = "list";
    BlueprintIcons_16["Locate"] = "locate";
    BlueprintIcons_16["Lock"] = "lock";
    BlueprintIcons_16["LogIn"] = "log-in";
    BlueprintIcons_16["LogOut"] = "log-out";
    BlueprintIcons_16["Manual"] = "manual";
    BlueprintIcons_16["ManuallyEnteredData"] = "manually-entered-data";
    BlueprintIcons_16["MapCreate"] = "map-create";
    BlueprintIcons_16["MapMarker"] = "map-marker";
    BlueprintIcons_16["Map"] = "map";
    BlueprintIcons_16["Maximize"] = "maximize";
    BlueprintIcons_16["Media"] = "media";
    BlueprintIcons_16["MenuClosed"] = "menu-closed";
    BlueprintIcons_16["MenuOpen"] = "menu-open";
    BlueprintIcons_16["Menu"] = "menu";
    BlueprintIcons_16["MergeColumns"] = "merge-columns";
    BlueprintIcons_16["MergeLinks"] = "merge-links";
    BlueprintIcons_16["Minimize"] = "minimize";
    BlueprintIcons_16["Minus"] = "minus";
    BlueprintIcons_16["MobilePhone"] = "mobile-phone";
    BlueprintIcons_16["MobileVideo"] = "mobile-video";
    BlueprintIcons_16["ModalFilled"] = "modal-filled";
    BlueprintIcons_16["Modal"] = "modal";
    BlueprintIcons_16["Moon"] = "moon";
    BlueprintIcons_16["More"] = "more";
    BlueprintIcons_16["Mountain"] = "mountain";
    BlueprintIcons_16["Move"] = "move";
    BlueprintIcons_16["Mugshot"] = "mugshot";
    BlueprintIcons_16["MultiSelect"] = "multi-select";
    BlueprintIcons_16["Music"] = "music";
    BlueprintIcons_16["NewDrawing"] = "new-drawing";
    BlueprintIcons_16["NewGridItem"] = "new-grid-item";
    BlueprintIcons_16["NewLayer"] = "new-layer";
    BlueprintIcons_16["NewLayers"] = "new-layers";
    BlueprintIcons_16["NewLink"] = "new-link";
    BlueprintIcons_16["NewObject"] = "new-object";
    BlueprintIcons_16["NewPerson"] = "new-person";
    BlueprintIcons_16["NewPrescription"] = "new-prescription";
    BlueprintIcons_16["NewTextBox"] = "new-text-box";
    BlueprintIcons_16["Ninja"] = "ninja";
    BlueprintIcons_16["NotEqualTo"] = "not-equal-to";
    BlueprintIcons_16["NotificationsSnooze"] = "notifications-snooze";
    BlueprintIcons_16["NotificationsUpdated"] = "notifications-updated";
    BlueprintIcons_16["Notifications"] = "notifications";
    BlueprintIcons_16["NumberedList"] = "numbered-list";
    BlueprintIcons_16["Numerical"] = "numerical";
    BlueprintIcons_16["Office"] = "office";
    BlueprintIcons_16["Offline"] = "offline";
    BlueprintIcons_16["OilField"] = "oil-field";
    BlueprintIcons_16["OneColumn"] = "one-column";
    BlueprintIcons_16["Outdated"] = "outdated";
    BlueprintIcons_16["PageLayout"] = "page-layout";
    BlueprintIcons_16["PanelStats"] = "panel-stats";
    BlueprintIcons_16["PanelTable"] = "panel-table";
    BlueprintIcons_16["Paperclip"] = "paperclip";
    BlueprintIcons_16["Paragraph"] = "paragraph";
    BlueprintIcons_16["PathSearch"] = "path-search";
    BlueprintIcons_16["Path"] = "path";
    BlueprintIcons_16["Pause"] = "pause";
    BlueprintIcons_16["People"] = "people";
    BlueprintIcons_16["Percentage"] = "percentage";
    BlueprintIcons_16["Person"] = "person";
    BlueprintIcons_16["Phone"] = "phone";
    BlueprintIcons_16["PieChart"] = "pie-chart";
    BlueprintIcons_16["Pin"] = "pin";
    BlueprintIcons_16["PivotTable"] = "pivot-table";
    BlueprintIcons_16["Pivot"] = "pivot";
    BlueprintIcons_16["Play"] = "play";
    BlueprintIcons_16["Plus"] = "plus";
    BlueprintIcons_16["PolygonFilter"] = "polygon-filter";
    BlueprintIcons_16["Power"] = "power";
    BlueprintIcons_16["PredictiveAnalysis"] = "predictive-analysis";
    BlueprintIcons_16["Prescription"] = "prescription";
    BlueprintIcons_16["Presentation"] = "presentation";
    BlueprintIcons_16["Print"] = "print";
    BlueprintIcons_16["Projects"] = "projects";
    BlueprintIcons_16["Properties"] = "properties";
    BlueprintIcons_16["Property"] = "property";
    BlueprintIcons_16["PublishFunction"] = "publish-function";
    BlueprintIcons_16["Pulse"] = "pulse";
    BlueprintIcons_16["Random"] = "random";
    BlueprintIcons_16["Record"] = "record";
    BlueprintIcons_16["Redo"] = "redo";
    BlueprintIcons_16["Refresh"] = "refresh";
    BlueprintIcons_16["RegressionChart"] = "regression-chart";
    BlueprintIcons_16["RemoveColumnLeft"] = "remove-column-left";
    BlueprintIcons_16["RemoveColumnRight"] = "remove-column-right";
    BlueprintIcons_16["RemoveColumn"] = "remove-column";
    BlueprintIcons_16["RemoveRowBottom"] = "remove-row-bottom";
    BlueprintIcons_16["RemoveRowTop"] = "remove-row-top";
    BlueprintIcons_16["Remove"] = "remove";
    BlueprintIcons_16["Repeat"] = "repeat";
    BlueprintIcons_16["Reset"] = "reset";
    BlueprintIcons_16["Resolve"] = "resolve";
    BlueprintIcons_16["Rig"] = "rig";
    BlueprintIcons_16["RightJoin"] = "right-join";
    BlueprintIcons_16["Ring"] = "ring";
    BlueprintIcons_16["RotateDocument"] = "rotate-document";
    BlueprintIcons_16["RotatePage"] = "rotate-page";
    BlueprintIcons_16["Route"] = "route";
    BlueprintIcons_16["Satellite"] = "satellite";
    BlueprintIcons_16["Saved"] = "saved";
    BlueprintIcons_16["ScatterPlot"] = "scatter-plot";
    BlueprintIcons_16["SearchAround"] = "search-around";
    BlueprintIcons_16["SearchTemplate"] = "search-template";
    BlueprintIcons_16["SearchText"] = "search-text";
    BlueprintIcons_16["Search"] = "search";
    BlueprintIcons_16["SegmentedControl"] = "segmented-control";
    BlueprintIcons_16["Select"] = "select";
    BlueprintIcons_16["Selection"] = "selection";
    BlueprintIcons_16["SendMessage"] = "send-message";
    BlueprintIcons_16["SendToGraph"] = "send-to-graph";
    BlueprintIcons_16["SendToMap"] = "send-to-map";
    BlueprintIcons_16["SendTo"] = "send-to";
    BlueprintIcons_16["SeriesAdd"] = "series-add";
    BlueprintIcons_16["SeriesConfiguration"] = "series-configuration";
    BlueprintIcons_16["SeriesDerived"] = "series-derived";
    BlueprintIcons_16["SeriesFiltered"] = "series-filtered";
    BlueprintIcons_16["SeriesSearch"] = "series-search";
    BlueprintIcons_16["Settings"] = "settings";
    BlueprintIcons_16["Shapes"] = "shapes";
    BlueprintIcons_16["Share"] = "share";
    BlueprintIcons_16["SharedFilter"] = "shared-filter";
    BlueprintIcons_16["Shield"] = "shield";
    BlueprintIcons_16["Shop"] = "shop";
    BlueprintIcons_16["ShoppingCart"] = "shopping-cart";
    BlueprintIcons_16["SignalSearch"] = "signal-search";
    BlueprintIcons_16["SimCard"] = "sim-card";
    BlueprintIcons_16["Slash"] = "slash";
    BlueprintIcons_16["SmallCross"] = "small-cross";
    BlueprintIcons_16["SmallMinus"] = "small-minus";
    BlueprintIcons_16["SmallPlus"] = "small-plus";
    BlueprintIcons_16["SmallTick"] = "small-tick";
    BlueprintIcons_16["Snowflake"] = "snowflake";
    BlueprintIcons_16["SocialMedia"] = "social-media";
    BlueprintIcons_16["SortAlphabeticalDesc"] = "sort-alphabetical-desc";
    BlueprintIcons_16["SortAlphabetical"] = "sort-alphabetical";
    BlueprintIcons_16["SortAsc"] = "sort-asc";
    BlueprintIcons_16["SortDesc"] = "sort-desc";
    BlueprintIcons_16["SortNumericalDesc"] = "sort-numerical-desc";
    BlueprintIcons_16["SortNumerical"] = "sort-numerical";
    BlueprintIcons_16["Sort"] = "sort";
    BlueprintIcons_16["SplitColumns"] = "split-columns";
    BlueprintIcons_16["Square"] = "square";
    BlueprintIcons_16["StackedChart"] = "stacked-chart";
    BlueprintIcons_16["StarEmpty"] = "star-empty";
    BlueprintIcons_16["Star"] = "star";
    BlueprintIcons_16["StepBackward"] = "step-backward";
    BlueprintIcons_16["StepChart"] = "step-chart";
    BlueprintIcons_16["StepForward"] = "step-forward";
    BlueprintIcons_16["Stop"] = "stop";
    BlueprintIcons_16["Stopwatch"] = "stopwatch";
    BlueprintIcons_16["Strikethrough"] = "strikethrough";
    BlueprintIcons_16["Style"] = "style";
    BlueprintIcons_16["SwapHorizontal"] = "swap-horizontal";
    BlueprintIcons_16["SwapVertical"] = "swap-vertical";
    BlueprintIcons_16["Switch"] = "switch";
    BlueprintIcons_16["SymbolCircle"] = "symbol-circle";
    BlueprintIcons_16["SymbolCross"] = "symbol-cross";
    BlueprintIcons_16["SymbolDiamond"] = "symbol-diamond";
    BlueprintIcons_16["SymbolSquare"] = "symbol-square";
    BlueprintIcons_16["SymbolTriangleDown"] = "symbol-triangle-down";
    BlueprintIcons_16["SymbolTriangleUp"] = "symbol-triangle-up";
    BlueprintIcons_16["Tag"] = "tag";
    BlueprintIcons_16["TakeAction"] = "take-action";
    BlueprintIcons_16["Taxi"] = "taxi";
    BlueprintIcons_16["TextHighlight"] = "text-highlight";
    BlueprintIcons_16["ThDerived"] = "th-derived";
    BlueprintIcons_16["ThDisconnect"] = "th-disconnect";
    BlueprintIcons_16["ThFiltered"] = "th-filtered";
    BlueprintIcons_16["ThList"] = "th-list";
    BlueprintIcons_16["Th"] = "th";
    BlueprintIcons_16["ThumbsDown"] = "thumbs-down";
    BlueprintIcons_16["ThumbsUp"] = "thumbs-up";
    BlueprintIcons_16["TickCircle"] = "tick-circle";
    BlueprintIcons_16["Tick"] = "tick";
    BlueprintIcons_16["Time"] = "time";
    BlueprintIcons_16["TimelineAreaChart"] = "timeline-area-chart";
    BlueprintIcons_16["TimelineBarChart"] = "timeline-bar-chart";
    BlueprintIcons_16["TimelineEvents"] = "timeline-events";
    BlueprintIcons_16["TimelineLineChart"] = "timeline-line-chart";
    BlueprintIcons_16["Tint"] = "tint";
    BlueprintIcons_16["Torch"] = "torch";
    BlueprintIcons_16["Tractor"] = "tractor";
    BlueprintIcons_16["Train"] = "train";
    BlueprintIcons_16["Translate"] = "translate";
    BlueprintIcons_16["Trash"] = "trash";
    BlueprintIcons_16["Tree"] = "tree";
    BlueprintIcons_16["TrendingDown"] = "trending-down";
    BlueprintIcons_16["TrendingUp"] = "trending-up";
    BlueprintIcons_16["Truck"] = "truck";
    BlueprintIcons_16["TwoColumns"] = "two-columns";
    BlueprintIcons_16["Unarchive"] = "unarchive";
    BlueprintIcons_16["Underline"] = "underline";
    BlueprintIcons_16["Undo"] = "undo";
    BlueprintIcons_16["UngroupObjects"] = "ungroup-objects";
    BlueprintIcons_16["UnknownVehicle"] = "unknown-vehicle";
    BlueprintIcons_16["Unlock"] = "unlock";
    BlueprintIcons_16["Unpin"] = "unpin";
    BlueprintIcons_16["Unresolve"] = "unresolve";
    BlueprintIcons_16["Updated"] = "updated";
    BlueprintIcons_16["Upload"] = "upload";
    BlueprintIcons_16["User"] = "user";
    BlueprintIcons_16["Variable"] = "variable";
    BlueprintIcons_16["VerticalBarChartAsc"] = "vertical-bar-chart-asc";
    BlueprintIcons_16["VerticalBarChartDesc"] = "vertical-bar-chart-desc";
    BlueprintIcons_16["VerticalDistribution"] = "vertical-distribution";
    BlueprintIcons_16["Video"] = "video";
    BlueprintIcons_16["Virus"] = "virus";
    BlueprintIcons_16["VolumeDown"] = "volume-down";
    BlueprintIcons_16["VolumeOff"] = "volume-off";
    BlueprintIcons_16["VolumeUp"] = "volume-up";
    BlueprintIcons_16["Walk"] = "walk";
    BlueprintIcons_16["WarningSign"] = "warning-sign";
    BlueprintIcons_16["WaterfallChart"] = "waterfall-chart";
    BlueprintIcons_16["WidgetButton"] = "widget-button";
    BlueprintIcons_16["WidgetFooter"] = "widget-footer";
    BlueprintIcons_16["WidgetHeader"] = "widget-header";
    BlueprintIcons_16["Widget"] = "widget";
    BlueprintIcons_16["Wrench"] = "wrench";
    BlueprintIcons_16["ZoomIn"] = "zoom-in";
    BlueprintIcons_16["ZoomOut"] = "zoom-out";
    BlueprintIcons_16["ZoomToFit"] = "zoom-to-fit";
})(BlueprintIcons_16 || (BlueprintIcons_16 = {}));
export var BLUEPRINT_ICONS_16_CODEPOINTS = (_a = {},
    _a[BlueprintIcons_16.AddColumnLeft] = "61697",
    _a[BlueprintIcons_16.AddColumnRight] = "61698",
    _a[BlueprintIcons_16.AddLocation] = "61699",
    _a[BlueprintIcons_16.AddRowBottom] = "61700",
    _a[BlueprintIcons_16.AddRowTop] = "61701",
    _a[BlueprintIcons_16.AddToArtifact] = "61702",
    _a[BlueprintIcons_16.AddToFolder] = "61703",
    _a[BlueprintIcons_16.Add] = "61704",
    _a[BlueprintIcons_16.Airplane] = "61705",
    _a[BlueprintIcons_16.AlignCenter] = "61706",
    _a[BlueprintIcons_16.AlignJustify] = "61707",
    _a[BlueprintIcons_16.AlignLeft] = "61708",
    _a[BlueprintIcons_16.AlignRight] = "61709",
    _a[BlueprintIcons_16.AlignmentBottom] = "61710",
    _a[BlueprintIcons_16.AlignmentHorizontalCenter] = "61711",
    _a[BlueprintIcons_16.AlignmentLeft] = "61712",
    _a[BlueprintIcons_16.AlignmentRight] = "61713",
    _a[BlueprintIcons_16.AlignmentTop] = "61714",
    _a[BlueprintIcons_16.AlignmentVerticalCenter] = "61715",
    _a[BlueprintIcons_16.Annotation] = "61716",
    _a[BlueprintIcons_16.AppHeader] = "61717",
    _a[BlueprintIcons_16.Application] = "61718",
    _a[BlueprintIcons_16.Applications] = "61719",
    _a[BlueprintIcons_16.Archive] = "61720",
    _a[BlueprintIcons_16.ArrayBoolean] = "61721",
    _a[BlueprintIcons_16.ArrayDate] = "61722",
    _a[BlueprintIcons_16.ArrayNumeric] = "61723",
    _a[BlueprintIcons_16.ArrayString] = "61724",
    _a[BlueprintIcons_16.ArrayTimestamp] = "61725",
    _a[BlueprintIcons_16.Array] = "61726",
    _a[BlueprintIcons_16.ArrowBottomLeft] = "61727",
    _a[BlueprintIcons_16.ArrowBottomRight] = "61728",
    _a[BlueprintIcons_16.ArrowDown] = "61729",
    _a[BlueprintIcons_16.ArrowLeft] = "61730",
    _a[BlueprintIcons_16.ArrowRight] = "61731",
    _a[BlueprintIcons_16.ArrowTopLeft] = "61732",
    _a[BlueprintIcons_16.ArrowTopRight] = "61733",
    _a[BlueprintIcons_16.ArrowUp] = "61734",
    _a[BlueprintIcons_16.ArrowsHorizontal] = "61735",
    _a[BlueprintIcons_16.ArrowsVertical] = "61736",
    _a[BlueprintIcons_16.Asterisk] = "61737",
    _a[BlueprintIcons_16.AutomaticUpdates] = "61738",
    _a[BlueprintIcons_16.Backlink] = "61739",
    _a[BlueprintIcons_16.Badge] = "61740",
    _a[BlueprintIcons_16.BanCircle] = "61741",
    _a[BlueprintIcons_16.BankAccount] = "61742",
    _a[BlueprintIcons_16.Barcode] = "61743",
    _a[BlueprintIcons_16.Blank] = "61744",
    _a[BlueprintIcons_16.BlockedPerson] = "61745",
    _a[BlueprintIcons_16.Bold] = "61746",
    _a[BlueprintIcons_16.Book] = "61747",
    _a[BlueprintIcons_16.Bookmark] = "61748",
    _a[BlueprintIcons_16.Box] = "61749",
    _a[BlueprintIcons_16.Briefcase] = "61750",
    _a[BlueprintIcons_16.BringData] = "61751",
    _a[BlueprintIcons_16.Build] = "61752",
    _a[BlueprintIcons_16.Calculator] = "61753",
    _a[BlueprintIcons_16.Calendar] = "61754",
    _a[BlueprintIcons_16.Camera] = "61755",
    _a[BlueprintIcons_16.CaretDown] = "61756",
    _a[BlueprintIcons_16.CaretLeft] = "61757",
    _a[BlueprintIcons_16.CaretRight] = "61758",
    _a[BlueprintIcons_16.CaretUp] = "61759",
    _a[BlueprintIcons_16.CellTower] = "61760",
    _a[BlueprintIcons_16.Changes] = "61761",
    _a[BlueprintIcons_16.Chart] = "61762",
    _a[BlueprintIcons_16.Chat] = "61763",
    _a[BlueprintIcons_16.ChevronBackward] = "61764",
    _a[BlueprintIcons_16.ChevronDown] = "61765",
    _a[BlueprintIcons_16.ChevronForward] = "61766",
    _a[BlueprintIcons_16.ChevronLeft] = "61767",
    _a[BlueprintIcons_16.ChevronRight] = "61768",
    _a[BlueprintIcons_16.ChevronUp] = "61769",
    _a[BlueprintIcons_16.CircleArrowDown] = "61770",
    _a[BlueprintIcons_16.CircleArrowLeft] = "61771",
    _a[BlueprintIcons_16.CircleArrowRight] = "61772",
    _a[BlueprintIcons_16.CircleArrowUp] = "61773",
    _a[BlueprintIcons_16.Circle] = "61774",
    _a[BlueprintIcons_16.Citation] = "61775",
    _a[BlueprintIcons_16.Clean] = "61776",
    _a[BlueprintIcons_16.Clipboard] = "61777",
    _a[BlueprintIcons_16.CloudDownload] = "61778",
    _a[BlueprintIcons_16.CloudUpload] = "61779",
    _a[BlueprintIcons_16.Cloud] = "61780",
    _a[BlueprintIcons_16.CodeBlock] = "61781",
    _a[BlueprintIcons_16.Code] = "61782",
    _a[BlueprintIcons_16.Cog] = "61783",
    _a[BlueprintIcons_16.CollapseAll] = "61784",
    _a[BlueprintIcons_16.ColumnLayout] = "61785",
    _a[BlueprintIcons_16.Comment] = "61786",
    _a[BlueprintIcons_16.Comparison] = "61787",
    _a[BlueprintIcons_16.Compass] = "61788",
    _a[BlueprintIcons_16.Compressed] = "61789",
    _a[BlueprintIcons_16.Confirm] = "61790",
    _a[BlueprintIcons_16.Console] = "61791",
    _a[BlueprintIcons_16.Contrast] = "61792",
    _a[BlueprintIcons_16.Control] = "61793",
    _a[BlueprintIcons_16.CreditCard] = "61794",
    _a[BlueprintIcons_16.Cross] = "61795",
    _a[BlueprintIcons_16.Crown] = "61796",
    _a[BlueprintIcons_16.CubeAdd] = "61797",
    _a[BlueprintIcons_16.CubeRemove] = "61798",
    _a[BlueprintIcons_16.Cube] = "61799",
    _a[BlueprintIcons_16.CurvedRangeChart] = "61800",
    _a[BlueprintIcons_16.Cut] = "61801",
    _a[BlueprintIcons_16.Cycle] = "61802",
    _a[BlueprintIcons_16.Dashboard] = "61803",
    _a[BlueprintIcons_16.DataConnection] = "61804",
    _a[BlueprintIcons_16.DataLineage] = "61805",
    _a[BlueprintIcons_16.Database] = "61806",
    _a[BlueprintIcons_16.Delete] = "61807",
    _a[BlueprintIcons_16.Delta] = "61808",
    _a[BlueprintIcons_16.DeriveColumn] = "61809",
    _a[BlueprintIcons_16.Desktop] = "61810",
    _a[BlueprintIcons_16.Diagnosis] = "61811",
    _a[BlueprintIcons_16.DiagramTree] = "61812",
    _a[BlueprintIcons_16.DirectionLeft] = "61813",
    _a[BlueprintIcons_16.DirectionRight] = "61814",
    _a[BlueprintIcons_16.Disable] = "61815",
    _a[BlueprintIcons_16.DocumentOpen] = "61816",
    _a[BlueprintIcons_16.DocumentShare] = "61817",
    _a[BlueprintIcons_16.Document] = "61818",
    _a[BlueprintIcons_16.Dollar] = "61819",
    _a[BlueprintIcons_16.Dot] = "61820",
    _a[BlueprintIcons_16.DoubleCaretHorizontal] = "61821",
    _a[BlueprintIcons_16.DoubleCaretVertical] = "61822",
    _a[BlueprintIcons_16.DoubleChevronDown] = "61823",
    _a[BlueprintIcons_16.DoubleChevronLeft] = "61824",
    _a[BlueprintIcons_16.DoubleChevronRight] = "61825",
    _a[BlueprintIcons_16.DoubleChevronUp] = "61826",
    _a[BlueprintIcons_16.DoughnutChart] = "61827",
    _a[BlueprintIcons_16.Download] = "61828",
    _a[BlueprintIcons_16.DragHandleHorizontal] = "61829",
    _a[BlueprintIcons_16.DragHandleVertical] = "61830",
    _a[BlueprintIcons_16.Draw] = "61831",
    _a[BlueprintIcons_16.DrawerLeftFilled] = "61832",
    _a[BlueprintIcons_16.DrawerLeft] = "61833",
    _a[BlueprintIcons_16.DrawerRightFilled] = "61834",
    _a[BlueprintIcons_16.DrawerRight] = "61835",
    _a[BlueprintIcons_16.DriveTime] = "61836",
    _a[BlueprintIcons_16.Duplicate] = "61837",
    _a[BlueprintIcons_16.Edit] = "61838",
    _a[BlueprintIcons_16.Eject] = "61839",
    _a[BlueprintIcons_16.Emoji] = "61840",
    _a[BlueprintIcons_16.Endorsed] = "61841",
    _a[BlueprintIcons_16.Envelope] = "61842",
    _a[BlueprintIcons_16.Equals] = "61843",
    _a[BlueprintIcons_16.Eraser] = "61844",
    _a[BlueprintIcons_16.Error] = "61845",
    _a[BlueprintIcons_16.Euro] = "61846",
    _a[BlueprintIcons_16.Exchange] = "61847",
    _a[BlueprintIcons_16.ExcludeRow] = "61848",
    _a[BlueprintIcons_16.ExpandAll] = "61849",
    _a[BlueprintIcons_16.Export] = "61850",
    _a[BlueprintIcons_16.EyeOff] = "61851",
    _a[BlueprintIcons_16.EyeOn] = "61852",
    _a[BlueprintIcons_16.EyeOpen] = "61853",
    _a[BlueprintIcons_16.FastBackward] = "61854",
    _a[BlueprintIcons_16.FastForward] = "61855",
    _a[BlueprintIcons_16.FeedSubscribed] = "61856",
    _a[BlueprintIcons_16.Feed] = "61857",
    _a[BlueprintIcons_16.Film] = "61858",
    _a[BlueprintIcons_16.FilterKeep] = "61859",
    _a[BlueprintIcons_16.FilterList] = "61860",
    _a[BlueprintIcons_16.FilterOpen] = "61861",
    _a[BlueprintIcons_16.FilterRemove] = "61862",
    _a[BlueprintIcons_16.Filter] = "61863",
    _a[BlueprintIcons_16.Flag] = "61864",
    _a[BlueprintIcons_16.Flame] = "61865",
    _a[BlueprintIcons_16.Flash] = "61866",
    _a[BlueprintIcons_16.FloppyDisk] = "61867",
    _a[BlueprintIcons_16.FlowBranch] = "61868",
    _a[BlueprintIcons_16.FlowEnd] = "61869",
    _a[BlueprintIcons_16.FlowLinear] = "61870",
    _a[BlueprintIcons_16.FlowReviewBranch] = "61871",
    _a[BlueprintIcons_16.FlowReview] = "61872",
    _a[BlueprintIcons_16.Flows] = "61873",
    _a[BlueprintIcons_16.FolderClose] = "61874",
    _a[BlueprintIcons_16.FolderNew] = "61875",
    _a[BlueprintIcons_16.FolderOpen] = "61876",
    _a[BlueprintIcons_16.FolderSharedOpen] = "61877",
    _a[BlueprintIcons_16.FolderShared] = "61878",
    _a[BlueprintIcons_16.Follower] = "61879",
    _a[BlueprintIcons_16.Following] = "61880",
    _a[BlueprintIcons_16.Font] = "61881",
    _a[BlueprintIcons_16.Fork] = "61882",
    _a[BlueprintIcons_16.Form] = "61883",
    _a[BlueprintIcons_16.FullCircle] = "61884",
    _a[BlueprintIcons_16.FullStackedChart] = "61885",
    _a[BlueprintIcons_16.Fullscreen] = "61886",
    _a[BlueprintIcons_16.Function] = "61887",
    _a[BlueprintIcons_16.GanttChart] = "61888",
    _a[BlueprintIcons_16.Geofence] = "61889",
    _a[BlueprintIcons_16.Geolocation] = "61890",
    _a[BlueprintIcons_16.Geosearch] = "61891",
    _a[BlueprintIcons_16.GitBranch] = "61892",
    _a[BlueprintIcons_16.GitCommit] = "61893",
    _a[BlueprintIcons_16.GitMerge] = "61894",
    _a[BlueprintIcons_16.GitNewBranch] = "61895",
    _a[BlueprintIcons_16.GitPull] = "61896",
    _a[BlueprintIcons_16.GitPush] = "61897",
    _a[BlueprintIcons_16.GitRepo] = "61898",
    _a[BlueprintIcons_16.Glass] = "61899",
    _a[BlueprintIcons_16.GlobeNetwork] = "61900",
    _a[BlueprintIcons_16.Globe] = "61901",
    _a[BlueprintIcons_16.GraphRemove] = "61902",
    _a[BlueprintIcons_16.Graph] = "61903",
    _a[BlueprintIcons_16.GreaterThanOrEqualTo] = "61904",
    _a[BlueprintIcons_16.GreaterThan] = "61905",
    _a[BlueprintIcons_16.GridView] = "61906",
    _a[BlueprintIcons_16.Grid] = "61907",
    _a[BlueprintIcons_16.GroupObjects] = "61908",
    _a[BlueprintIcons_16.GroupedBarChart] = "61909",
    _a[BlueprintIcons_16.HandDown] = "61910",
    _a[BlueprintIcons_16.HandLeft] = "61911",
    _a[BlueprintIcons_16.HandRight] = "61912",
    _a[BlueprintIcons_16.HandUp] = "61913",
    _a[BlueprintIcons_16.Hand] = "61914",
    _a[BlueprintIcons_16.Hat] = "61915",
    _a[BlueprintIcons_16.HeaderOne] = "61916",
    _a[BlueprintIcons_16.HeaderTwo] = "61917",
    _a[BlueprintIcons_16.Header] = "61918",
    _a[BlueprintIcons_16.Headset] = "61919",
    _a[BlueprintIcons_16.HeartBroken] = "61920",
    _a[BlueprintIcons_16.Heart] = "61921",
    _a[BlueprintIcons_16.HeatGrid] = "61922",
    _a[BlueprintIcons_16.Heatmap] = "61923",
    _a[BlueprintIcons_16.Help] = "61924",
    _a[BlueprintIcons_16.HelperManagement] = "61925",
    _a[BlueprintIcons_16.HighPriority] = "61926",
    _a[BlueprintIcons_16.Highlight] = "61927",
    _a[BlueprintIcons_16.History] = "61928",
    _a[BlueprintIcons_16.Home] = "61929",
    _a[BlueprintIcons_16.HorizontalBarChartAsc] = "61930",
    _a[BlueprintIcons_16.HorizontalBarChartDesc] = "61931",
    _a[BlueprintIcons_16.HorizontalBarChart] = "61932",
    _a[BlueprintIcons_16.HorizontalDistribution] = "61933",
    _a[BlueprintIcons_16.IdNumber] = "61934",
    _a[BlueprintIcons_16.ImageRotateLeft] = "61935",
    _a[BlueprintIcons_16.ImageRotateRight] = "61936",
    _a[BlueprintIcons_16.Import] = "61937",
    _a[BlueprintIcons_16.InboxFiltered] = "61938",
    _a[BlueprintIcons_16.InboxGeo] = "61939",
    _a[BlueprintIcons_16.InboxSearch] = "61940",
    _a[BlueprintIcons_16.InboxUpdate] = "61941",
    _a[BlueprintIcons_16.Inbox] = "61942",
    _a[BlueprintIcons_16.InfoSign] = "61943",
    _a[BlueprintIcons_16.Inheritance] = "61944",
    _a[BlueprintIcons_16.InheritedGroup] = "61945",
    _a[BlueprintIcons_16.InnerJoin] = "61946",
    _a[BlueprintIcons_16.Insert] = "61947",
    _a[BlueprintIcons_16.Intersection] = "61948",
    _a[BlueprintIcons_16.IpAddress] = "61949",
    _a[BlueprintIcons_16.IssueClosed] = "61950",
    _a[BlueprintIcons_16.IssueNew] = "61951",
    _a[BlueprintIcons_16.Issue] = "61952",
    _a[BlueprintIcons_16.Italic] = "61953",
    _a[BlueprintIcons_16.JoinTable] = "61954",
    _a[BlueprintIcons_16.KeyBackspace] = "61955",
    _a[BlueprintIcons_16.KeyCommand] = "61956",
    _a[BlueprintIcons_16.KeyControl] = "61957",
    _a[BlueprintIcons_16.KeyDelete] = "61958",
    _a[BlueprintIcons_16.KeyEnter] = "61959",
    _a[BlueprintIcons_16.KeyEscape] = "61960",
    _a[BlueprintIcons_16.KeyOption] = "61961",
    _a[BlueprintIcons_16.KeyShift] = "61962",
    _a[BlueprintIcons_16.KeyTab] = "61963",
    _a[BlueprintIcons_16.Key] = "61964",
    _a[BlueprintIcons_16.KnownVehicle] = "61965",
    _a[BlueprintIcons_16.LabTest] = "61966",
    _a[BlueprintIcons_16.Label] = "61967",
    _a[BlueprintIcons_16.LayerOutline] = "61968",
    _a[BlueprintIcons_16.Layer] = "61969",
    _a[BlueprintIcons_16.Layers] = "61970",
    _a[BlueprintIcons_16.LayoutAuto] = "61971",
    _a[BlueprintIcons_16.LayoutBalloon] = "61972",
    _a[BlueprintIcons_16.LayoutCircle] = "61973",
    _a[BlueprintIcons_16.LayoutGrid] = "61974",
    _a[BlueprintIcons_16.LayoutGroupBy] = "61975",
    _a[BlueprintIcons_16.LayoutHierarchy] = "61976",
    _a[BlueprintIcons_16.LayoutLinear] = "61977",
    _a[BlueprintIcons_16.LayoutSkewGrid] = "61978",
    _a[BlueprintIcons_16.LayoutSortedClusters] = "61979",
    _a[BlueprintIcons_16.Layout] = "61980",
    _a[BlueprintIcons_16.Learning] = "61981",
    _a[BlueprintIcons_16.LeftJoin] = "61982",
    _a[BlueprintIcons_16.LessThanOrEqualTo] = "61983",
    _a[BlueprintIcons_16.LessThan] = "61984",
    _a[BlueprintIcons_16.Lifesaver] = "61985",
    _a[BlueprintIcons_16.Lightbulb] = "61986",
    _a[BlueprintIcons_16.Link] = "61987",
    _a[BlueprintIcons_16.ListColumns] = "61988",
    _a[BlueprintIcons_16.ListDetailView] = "61989",
    _a[BlueprintIcons_16.List] = "61990",
    _a[BlueprintIcons_16.Locate] = "61991",
    _a[BlueprintIcons_16.Lock] = "61992",
    _a[BlueprintIcons_16.LogIn] = "61993",
    _a[BlueprintIcons_16.LogOut] = "61994",
    _a[BlueprintIcons_16.Manual] = "61995",
    _a[BlueprintIcons_16.ManuallyEnteredData] = "61996",
    _a[BlueprintIcons_16.MapCreate] = "61997",
    _a[BlueprintIcons_16.MapMarker] = "61998",
    _a[BlueprintIcons_16.Map] = "61999",
    _a[BlueprintIcons_16.Maximize] = "62000",
    _a[BlueprintIcons_16.Media] = "62001",
    _a[BlueprintIcons_16.MenuClosed] = "62002",
    _a[BlueprintIcons_16.MenuOpen] = "62003",
    _a[BlueprintIcons_16.Menu] = "62004",
    _a[BlueprintIcons_16.MergeColumns] = "62005",
    _a[BlueprintIcons_16.MergeLinks] = "62006",
    _a[BlueprintIcons_16.Minimize] = "62007",
    _a[BlueprintIcons_16.Minus] = "62008",
    _a[BlueprintIcons_16.MobilePhone] = "62009",
    _a[BlueprintIcons_16.MobileVideo] = "62010",
    _a[BlueprintIcons_16.ModalFilled] = "62011",
    _a[BlueprintIcons_16.Modal] = "62012",
    _a[BlueprintIcons_16.Moon] = "62013",
    _a[BlueprintIcons_16.More] = "62014",
    _a[BlueprintIcons_16.Mountain] = "62015",
    _a[BlueprintIcons_16.Move] = "62016",
    _a[BlueprintIcons_16.Mugshot] = "62017",
    _a[BlueprintIcons_16.MultiSelect] = "62018",
    _a[BlueprintIcons_16.Music] = "62019",
    _a[BlueprintIcons_16.NewDrawing] = "62020",
    _a[BlueprintIcons_16.NewGridItem] = "62021",
    _a[BlueprintIcons_16.NewLayer] = "62022",
    _a[BlueprintIcons_16.NewLayers] = "62023",
    _a[BlueprintIcons_16.NewLink] = "62024",
    _a[BlueprintIcons_16.NewObject] = "62025",
    _a[BlueprintIcons_16.NewPerson] = "62026",
    _a[BlueprintIcons_16.NewPrescription] = "62027",
    _a[BlueprintIcons_16.NewTextBox] = "62028",
    _a[BlueprintIcons_16.Ninja] = "62029",
    _a[BlueprintIcons_16.NotEqualTo] = "62030",
    _a[BlueprintIcons_16.NotificationsSnooze] = "62031",
    _a[BlueprintIcons_16.NotificationsUpdated] = "62032",
    _a[BlueprintIcons_16.Notifications] = "62033",
    _a[BlueprintIcons_16.NumberedList] = "62034",
    _a[BlueprintIcons_16.Numerical] = "62035",
    _a[BlueprintIcons_16.Office] = "62036",
    _a[BlueprintIcons_16.Offline] = "62037",
    _a[BlueprintIcons_16.OilField] = "62038",
    _a[BlueprintIcons_16.OneColumn] = "62039",
    _a[BlueprintIcons_16.Outdated] = "62040",
    _a[BlueprintIcons_16.PageLayout] = "62041",
    _a[BlueprintIcons_16.PanelStats] = "62042",
    _a[BlueprintIcons_16.PanelTable] = "62043",
    _a[BlueprintIcons_16.Paperclip] = "62044",
    _a[BlueprintIcons_16.Paragraph] = "62045",
    _a[BlueprintIcons_16.PathSearch] = "62046",
    _a[BlueprintIcons_16.Path] = "62047",
    _a[BlueprintIcons_16.Pause] = "62048",
    _a[BlueprintIcons_16.People] = "62049",
    _a[BlueprintIcons_16.Percentage] = "62050",
    _a[BlueprintIcons_16.Person] = "62051",
    _a[BlueprintIcons_16.Phone] = "62052",
    _a[BlueprintIcons_16.PieChart] = "62053",
    _a[BlueprintIcons_16.Pin] = "62054",
    _a[BlueprintIcons_16.PivotTable] = "62055",
    _a[BlueprintIcons_16.Pivot] = "62056",
    _a[BlueprintIcons_16.Play] = "62057",
    _a[BlueprintIcons_16.Plus] = "62058",
    _a[BlueprintIcons_16.PolygonFilter] = "62059",
    _a[BlueprintIcons_16.Power] = "62060",
    _a[BlueprintIcons_16.PredictiveAnalysis] = "62061",
    _a[BlueprintIcons_16.Prescription] = "62062",
    _a[BlueprintIcons_16.Presentation] = "62063",
    _a[BlueprintIcons_16.Print] = "62064",
    _a[BlueprintIcons_16.Projects] = "62065",
    _a[BlueprintIcons_16.Properties] = "62066",
    _a[BlueprintIcons_16.Property] = "62067",
    _a[BlueprintIcons_16.PublishFunction] = "62068",
    _a[BlueprintIcons_16.Pulse] = "62069",
    _a[BlueprintIcons_16.Random] = "62070",
    _a[BlueprintIcons_16.Record] = "62071",
    _a[BlueprintIcons_16.Redo] = "62072",
    _a[BlueprintIcons_16.Refresh] = "62073",
    _a[BlueprintIcons_16.RegressionChart] = "62074",
    _a[BlueprintIcons_16.RemoveColumnLeft] = "62075",
    _a[BlueprintIcons_16.RemoveColumnRight] = "62076",
    _a[BlueprintIcons_16.RemoveColumn] = "62077",
    _a[BlueprintIcons_16.RemoveRowBottom] = "62078",
    _a[BlueprintIcons_16.RemoveRowTop] = "62079",
    _a[BlueprintIcons_16.Remove] = "62080",
    _a[BlueprintIcons_16.Repeat] = "62081",
    _a[BlueprintIcons_16.Reset] = "62082",
    _a[BlueprintIcons_16.Resolve] = "62083",
    _a[BlueprintIcons_16.Rig] = "62084",
    _a[BlueprintIcons_16.RightJoin] = "62085",
    _a[BlueprintIcons_16.Ring] = "62086",
    _a[BlueprintIcons_16.RotateDocument] = "62087",
    _a[BlueprintIcons_16.RotatePage] = "62088",
    _a[BlueprintIcons_16.Route] = "62089",
    _a[BlueprintIcons_16.Satellite] = "62090",
    _a[BlueprintIcons_16.Saved] = "62091",
    _a[BlueprintIcons_16.ScatterPlot] = "62092",
    _a[BlueprintIcons_16.SearchAround] = "62093",
    _a[BlueprintIcons_16.SearchTemplate] = "62094",
    _a[BlueprintIcons_16.SearchText] = "62095",
    _a[BlueprintIcons_16.Search] = "62096",
    _a[BlueprintIcons_16.SegmentedControl] = "62097",
    _a[BlueprintIcons_16.Select] = "62098",
    _a[BlueprintIcons_16.Selection] = "62099",
    _a[BlueprintIcons_16.SendMessage] = "62100",
    _a[BlueprintIcons_16.SendToGraph] = "62101",
    _a[BlueprintIcons_16.SendToMap] = "62102",
    _a[BlueprintIcons_16.SendTo] = "62103",
    _a[BlueprintIcons_16.SeriesAdd] = "62104",
    _a[BlueprintIcons_16.SeriesConfiguration] = "62105",
    _a[BlueprintIcons_16.SeriesDerived] = "62106",
    _a[BlueprintIcons_16.SeriesFiltered] = "62107",
    _a[BlueprintIcons_16.SeriesSearch] = "62108",
    _a[BlueprintIcons_16.Settings] = "62109",
    _a[BlueprintIcons_16.Shapes] = "62110",
    _a[BlueprintIcons_16.Share] = "62111",
    _a[BlueprintIcons_16.SharedFilter] = "62112",
    _a[BlueprintIcons_16.Shield] = "62113",
    _a[BlueprintIcons_16.Shop] = "62114",
    _a[BlueprintIcons_16.ShoppingCart] = "62115",
    _a[BlueprintIcons_16.SignalSearch] = "62116",
    _a[BlueprintIcons_16.SimCard] = "62117",
    _a[BlueprintIcons_16.Slash] = "62118",
    _a[BlueprintIcons_16.SmallCross] = "62119",
    _a[BlueprintIcons_16.SmallMinus] = "62120",
    _a[BlueprintIcons_16.SmallPlus] = "62121",
    _a[BlueprintIcons_16.SmallTick] = "62122",
    _a[BlueprintIcons_16.Snowflake] = "62123",
    _a[BlueprintIcons_16.SocialMedia] = "62124",
    _a[BlueprintIcons_16.SortAlphabeticalDesc] = "62125",
    _a[BlueprintIcons_16.SortAlphabetical] = "62126",
    _a[BlueprintIcons_16.SortAsc] = "62127",
    _a[BlueprintIcons_16.SortDesc] = "62128",
    _a[BlueprintIcons_16.SortNumericalDesc] = "62129",
    _a[BlueprintIcons_16.SortNumerical] = "62130",
    _a[BlueprintIcons_16.Sort] = "62131",
    _a[BlueprintIcons_16.SplitColumns] = "62132",
    _a[BlueprintIcons_16.Square] = "62133",
    _a[BlueprintIcons_16.StackedChart] = "62134",
    _a[BlueprintIcons_16.StarEmpty] = "62135",
    _a[BlueprintIcons_16.Star] = "62136",
    _a[BlueprintIcons_16.StepBackward] = "62137",
    _a[BlueprintIcons_16.StepChart] = "62138",
    _a[BlueprintIcons_16.StepForward] = "62139",
    _a[BlueprintIcons_16.Stop] = "62140",
    _a[BlueprintIcons_16.Stopwatch] = "62141",
    _a[BlueprintIcons_16.Strikethrough] = "62142",
    _a[BlueprintIcons_16.Style] = "62143",
    _a[BlueprintIcons_16.SwapHorizontal] = "62144",
    _a[BlueprintIcons_16.SwapVertical] = "62145",
    _a[BlueprintIcons_16.Switch] = "62146",
    _a[BlueprintIcons_16.SymbolCircle] = "62147",
    _a[BlueprintIcons_16.SymbolCross] = "62148",
    _a[BlueprintIcons_16.SymbolDiamond] = "62149",
    _a[BlueprintIcons_16.SymbolSquare] = "62150",
    _a[BlueprintIcons_16.SymbolTriangleDown] = "62151",
    _a[BlueprintIcons_16.SymbolTriangleUp] = "62152",
    _a[BlueprintIcons_16.Tag] = "62153",
    _a[BlueprintIcons_16.TakeAction] = "62154",
    _a[BlueprintIcons_16.Taxi] = "62155",
    _a[BlueprintIcons_16.TextHighlight] = "62156",
    _a[BlueprintIcons_16.ThDerived] = "62157",
    _a[BlueprintIcons_16.ThDisconnect] = "62158",
    _a[BlueprintIcons_16.ThFiltered] = "62159",
    _a[BlueprintIcons_16.ThList] = "62160",
    _a[BlueprintIcons_16.Th] = "62161",
    _a[BlueprintIcons_16.ThumbsDown] = "62162",
    _a[BlueprintIcons_16.ThumbsUp] = "62163",
    _a[BlueprintIcons_16.TickCircle] = "62164",
    _a[BlueprintIcons_16.Tick] = "62165",
    _a[BlueprintIcons_16.Time] = "62166",
    _a[BlueprintIcons_16.TimelineAreaChart] = "62167",
    _a[BlueprintIcons_16.TimelineBarChart] = "62168",
    _a[BlueprintIcons_16.TimelineEvents] = "62169",
    _a[BlueprintIcons_16.TimelineLineChart] = "62170",
    _a[BlueprintIcons_16.Tint] = "62171",
    _a[BlueprintIcons_16.Torch] = "62172",
    _a[BlueprintIcons_16.Tractor] = "62173",
    _a[BlueprintIcons_16.Train] = "62174",
    _a[BlueprintIcons_16.Translate] = "62175",
    _a[BlueprintIcons_16.Trash] = "62176",
    _a[BlueprintIcons_16.Tree] = "62177",
    _a[BlueprintIcons_16.TrendingDown] = "62178",
    _a[BlueprintIcons_16.TrendingUp] = "62179",
    _a[BlueprintIcons_16.Truck] = "62180",
    _a[BlueprintIcons_16.TwoColumns] = "62181",
    _a[BlueprintIcons_16.Unarchive] = "62182",
    _a[BlueprintIcons_16.Underline] = "62183",
    _a[BlueprintIcons_16.Undo] = "62184",
    _a[BlueprintIcons_16.UngroupObjects] = "62185",
    _a[BlueprintIcons_16.UnknownVehicle] = "62186",
    _a[BlueprintIcons_16.Unlock] = "62187",
    _a[BlueprintIcons_16.Unpin] = "62188",
    _a[BlueprintIcons_16.Unresolve] = "62189",
    _a[BlueprintIcons_16.Updated] = "62190",
    _a[BlueprintIcons_16.Upload] = "62191",
    _a[BlueprintIcons_16.User] = "62192",
    _a[BlueprintIcons_16.Variable] = "62193",
    _a[BlueprintIcons_16.VerticalBarChartAsc] = "62194",
    _a[BlueprintIcons_16.VerticalBarChartDesc] = "62195",
    _a[BlueprintIcons_16.VerticalDistribution] = "62196",
    _a[BlueprintIcons_16.Video] = "62197",
    _a[BlueprintIcons_16.Virus] = "62198",
    _a[BlueprintIcons_16.VolumeDown] = "62199",
    _a[BlueprintIcons_16.VolumeOff] = "62200",
    _a[BlueprintIcons_16.VolumeUp] = "62201",
    _a[BlueprintIcons_16.Walk] = "62202",
    _a[BlueprintIcons_16.WarningSign] = "62203",
    _a[BlueprintIcons_16.WaterfallChart] = "62204",
    _a[BlueprintIcons_16.WidgetButton] = "62205",
    _a[BlueprintIcons_16.WidgetFooter] = "62206",
    _a[BlueprintIcons_16.WidgetHeader] = "62207",
    _a[BlueprintIcons_16.Widget] = "62208",
    _a[BlueprintIcons_16.Wrench] = "62209",
    _a[BlueprintIcons_16.ZoomIn] = "62210",
    _a[BlueprintIcons_16.ZoomOut] = "62211",
    _a[BlueprintIcons_16.ZoomToFit] = "62212",
    _a);
//# sourceMappingURL=blueprint-icons-16.js.map